import { useState } from 'react';
import { FaSlidersH, FaCrosshairs } from 'react-icons/fa';

import { IconButton, Checkbox, Stack, Typography } from '@mui/joy';

export type DisplayedLayers = {
  geoFences: boolean;
  dronePath: boolean;
  noFlyZones: boolean;
  wayPoints: boolean;
};

export interface OverlayMenuProps {
  userMoved: boolean;
  recenter: () => void;
  displayedLayers: DisplayedLayers;
  updateDisplayedLayers: (modifiedLayers: Partial<DisplayedLayers>) => void;
}

const OverlayMenu: React.FC<OverlayMenuProps> = ({ userMoved, recenter, displayedLayers, updateDisplayedLayers }) => {
  const [menuSelection, setMenuSelection] = useState<'none' | 'layers'>('none');

  return (
    <Stack direction='row' spacing={2}>
      <Stack spacing={1}>
        <IconButton
          size='sm'
          variant='soft'
          onClick={() => setMenuSelection((prev) => (prev === 'layers' ? 'none' : 'layers'))}
        >
          <FaSlidersH />
        </IconButton>
        {userMoved && (
          <IconButton size='sm' variant='soft' onClick={recenter}>
            <FaCrosshairs />
          </IconButton>
        )}
      </Stack>
      <Stack spacing={1}>
        {menuSelection === 'layers' && (
          <Stack className='bg-neutral-800 p-1 rounded'>
            <Stack direction='row' spacing={1}>
              <Checkbox
                checked={displayedLayers.geoFences}
                onChange={(e) => updateDisplayedLayers({ geoFences: e.target.checked })}
              />
              <Typography>Geofences</Typography>
            </Stack>
            <Stack direction='row' spacing={1}>
              <Checkbox
                checked={displayedLayers.noFlyZones}
                onChange={(e) => updateDisplayedLayers({ noFlyZones: e.target.checked })}
              />
              <Typography>No-Fly Zones</Typography>
            </Stack>
            <Stack direction='row' spacing={1}>
              <Checkbox
                checked={displayedLayers.dronePath}
                onChange={(e) => updateDisplayedLayers({ dronePath: e.target.checked })}
              />
              <Typography>Drone path</Typography>
            </Stack>
            <Stack direction='row' spacing={1}>
              <Checkbox
                checked={displayedLayers.wayPoints}
                onChange={(e) => updateDisplayedLayers({ wayPoints: e.target.checked })}
              />
              <Typography>Waypoints</Typography>
            </Stack>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default OverlayMenu;
